var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telegram logo"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1535_6402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0H48V48H0",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.2812 20.625C27.6562 20.375 27.9062 20.3438 28.0312 20.5312C28.1562 20.7188 28.0625 20.9688 27.75 21.2812C24.8438 24.2812 22.6875 25.9688 21.4688 27.375C20.9062 28 21.0625 28.625 21.9375 29.25L27.75 33.1875C30.0938 34.7812 30.8438 33.4688 31.125 31.875C32.1875 26.1875 32.9375 21.4688 33.375 17.7188C33.5625 16.3125 33.0938 15.5625 31.3125 16.125C29.625 16.625 23.5625 19.1562 13.125 23.7188C11.1562 24.4688 11.5312 25.3125 12.6562 25.6875C13.7812 26.0625 14.625 26.3438 15.75 26.625C16.875 26.9062 17.625 27 18.9375 26.1562M24.0938 6C28.8595 6.02482 33.4208 7.9386 36.7775 11.3216C40.1343 14.7047 42.0124 19.2809 41.9999 24.0466C41.9875 28.8124 40.0856 33.3787 36.7113 36.7442C33.337 40.1098 28.7658 41.9998 24 41.9998C19.2342 41.9998 14.663 40.1098 11.2887 36.7442C7.91436 33.3787 6.01247 28.8124 6.00006 24.0466C5.98765 19.2809 7.86573 14.7047 11.2225 11.3216C14.5792 7.9386 19.1405 6.02482 23.9062 6",
    fill: "url(#paint0_linear_1535_6402)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1535_6402",
    x1: 6,
    y1: 6,
    x2: 6,
    y2: 41.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1535_6402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 7.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/telegram-logo.b3cec603def6ddf7cd30339e054ff6f0.svg";
export { ForwardRef as ReactComponent };